import React, { createContext, useState } from "react";

const GlobalContext = createContext();

export const GlobalContextProvider = ({ children }) => {
  const [isUserAuth, setIsUserAuth] = useState(
    localStorage.getItem("loggedInUser") === "true" || "false"
  );

  return (
    <GlobalContext.Provider value={{ isUserAuth, setIsUserAuth }}>
      {children}
    </GlobalContext.Provider>
  );
};

export default GlobalContext;
